export default __webpack_public_path__ + "static/SCUBA_Leggings-1bc5a2306840b9c6ca75879089d687a7.png";